import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useLocation } from "react-router-dom";

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-20"}`}>{children}</main>
      <Footer />
    </div>
  );
}